import { Component, ViewChild, Testability, OnDestroy } from '@angular/core';
import { NewProjectEditService } from './new.project.form.service';
import { AppService } from '../../app.service';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { NewProjectViewService } from '../NewProjectViewComponent/new.project.view.service';
import { Formvalidator } from './new.project.form.formvalidator'
import { ActivatedRoute } from '@angular/router'; 
import { Location } from '@angular/common';
import { DateAdapter, MatDatepicker } from '@angular/material';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { EmployerViewService } from '../../EmployerComponent/EmployerViewComponent/employer.view.service';
import { EmployerFormService } from '../../EmployerComponent/EmployerFormComponent/employer.form.service';
import { Globals } from '../../globals';
import customerJson from "../../../assets/config/customer.json";
import translateJson from "../../../translate.json";
import { formatDate } from '@angular/common';
import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { ProjectSuaStatusType } from '../../shared/enum/ProjectSuaStatusType'
import { SearchDropdownComponent } from '../../shared/input/SearchableDropdown/search.dropdown.component';
import { ConfirmModalService } from 'app/shared/views/ConfirmModalComponent/confirm.modal.service';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { Subscription } from 'rxjs';
import { ProjectTreeModalComponent } from '../NewProjectViewComponent/ProjectTreeModalComponent/project.tree.modal.component';

import { DateUpdateFix } from '../../models/date-update-fix';
import { AuthenticationService } from '../../auth';

enum viewType {SECURITYHANDLER, PROJECTSECURITYMANAGER, BUSINESSMANAGER};

@Component({
    selector: 'project-comp',
    providers: [NewProjectEditService, AppService, Formvalidator, NewProjectViewService, ConfirmService, MatDatepicker, PersonFormService, EmployerViewService, EmployerFormService, ConfirmModalService, DateUpdateFix, NgxSmartModalService, AuthenticationService],
    templateUrl: './new.project.form.component.html',  
    styleUrls: ['../project.component.css'] 
})

export class NewProjectFormComponent implements OnDestroy {
    
    @ViewChild('validationModal') validationModal: ValidationModalComponent;
    @ViewChild('projectTreeModal') projectTreeModal: ProjectTreeModalComponent;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private projectHierarchyActive: boolean = customerJson.settings.projectHierarchyActive;
    private customerOrgId: string = customerJson.customer.organisationId;
    private project: any;
    private activeComponent: boolean;
    selectedSecClass = 1;
    statusOptions = [this.i18.sua.form.suaStatusProcSelect, this.i18.sua.form.suaStatusApprovedSelect, this.i18.sua.form.suaStatusNotApprovedSelect, this.i18.sua.form.suaStatusCancelledSelect];
    selectedCompany: any;
    companySelected: Boolean = false;
    suaGovForm: FormGroup;
    suaForm: FormGroup;
    showLoader: Boolean = false;
    type: String;
    id: String;
    employerId: String;
    edit: Boolean = false;
    controlReasons: FormGroup;
    projectLead: FormGroup;
    editReceiverPersonForm: FormGroup;
    reasonArray: any = [];
    ready: Boolean = false;
    contractor: any;
    companies: any = [];
    compIndustryArray: any = [];
    private previousType: String;
    selectedView: any;
    projectSuaStatusType = ProjectSuaStatusType;
    receiverPersonArray: Array<any> = [];
    rkReceiverActive: Boolean = customerJson.settings.RKReceiver;
    suaShowOperatorAndSupervisor: Boolean = customerJson.settings.suaShowOperatorAndSupervisor;
    edition: String = customerJson.edition;
    suaShowBusinessManager = customerJson.settings.suaShowBusinessManager;
    showLocalOffices: boolean = customerJson.settings.showLocalOffices;
    showLocalOfficesForLevel: number = customerJson.settings.showLocalOfficesForLevel;
    autoClearOrgNrOperator: Boolean = customerJson.settings.autoClearOrgNrOperator;
    autoGenerateCustomerSua: Boolean = false;
    private enableDigitalXmlExport:boolean = customerJson.settings.enableDigitalXmlExport;

    isCustomer: boolean = false;

    uniqueDefaultProjectNames: any = [];
    contractVoidDateExists: Boolean = false;

    suaOperatorFilterList: any = [];
    suaRegulatorFilterList: any = [];
    headSupplier: any = null;
    isPartOfHierarchy: boolean = false;

    showHierarchyFields: Boolean = false;
    showHierarchyHtml: Boolean = false;

    private subscription: Subscription = new Subscription();

    allMainOrganisationLocalOffices: any = [];
    projectSpecificLocalOffices: any = [];
    availableLocalOfficeStrings: any = [];
    addedLocalOfficeStrings: any = [];
    addButtonEnabled: boolean = false;
    removeButtonEnabled: boolean = false;
    numOfNotes:number = 0;
    selectedCompanyForm: FormGroup;
    selectedReceiverPersonId: string = '';
    separateListItemForm: FormGroup;
    addressCodeFilterList: any = [];
    addressCodeExists: boolean;
    selectedAddressCodeId: string = '';

    constructor(
        private service: NewProjectEditService,
        private viewService: NewProjectViewService,
        private formValidator: Formvalidator,
        private activatedRoute: ActivatedRoute,
        private companyService: EmployerFormService,
        private dateAdapter: DateAdapter<Date>,
        private confirmService: ConfirmService,
        private location: Location,
        private personFormService: PersonFormService,
        private employerViewService: EmployerViewService,
        private globals: Globals,
        private appService: AppService,
        private ConfirmModalService: ConfirmModalService,
        private dateUpdateFix: DateUpdateFix,
        private ngxSmartModalService: NgxSmartModalService,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('project');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.type = this.activatedRoute.snapshot.paramMap.get('type');
            this.setDefault();      
            if(this.id != null && this.type === 'edit') {
                this.editProject(this.id);
            } else if (this.id === null && this.type === 'new') {
                this.setDefault();
                //this.patchGlobals(this.type);
                this.getEmployers();
            }
            this.getAllAddressCodes();
            this.getAllUniqueDefaultProjectNames()
        }

    /**
     * Removes all stored subscriptions on component destruction.
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    /**
     * Initiates values
     */
    setDefault() {
        this.dateAdapter.setLocale('sv');
        this.selectedCompanyForm = new FormGroup({
            name: new FormControl()
        });
        this.suaGovForm = new FormGroup({
            id: new FormControl(),

            //Autofilled by config            
            orgNrOperator: new FormControl({value: null, disabled: false}),
            addressCodeOperator: new FormControl({value: null, disabled: false}),
            operatorName: new FormControl({value: null, disabled: false}),
            operatorNationalityCode: new FormControl(),

            orgNrRegulator: new FormControl({value: null, disabled: false}),
            addressCodeRegulator: new FormControl({value: null, disabled: false}),
            regulatorName: new FormControl({value: null, disabled: false}),

            newReceiverPerson: new FormControl(),
            selectedReceiverPerson: new FormControl(),

            generateSequenceNumber: new FormControl(false),
            suaDiaryUid: new FormControl(),
            suaName: new FormControl(),
            suaProjectStatus: new FormControl(),
            suaCompanyStatus: new FormControl(),
            supplierType: new FormControl(),
            parentId: new FormControl(),
            generateCustomerSUA: new FormControl(),

            compOrgId: new FormControl(),
            compName: new FormControl(),
            compIndustry: new FormControl(),

            compProjectName: new FormControl(),
            availableLocalOfficeName: new FormControl(),
            addedLocalOfficeName: new FormControl(),

            compSecContractLevel: new FormControl(),
            compSecContractDate: new FormControl(),
            contractVoidDate: new FormControl(),

            employerId: new FormControl(),
            
            secHandlerName: new FormControl(),
            secHandlerPhone: new FormControl(),
            secHandlerMail: new FormControl(),
            projectSecManagerName: new FormControl(),
            projectSecManagerPhone: new FormControl(),
            projectSecManagerMail: new FormControl(),
            businessManagerName: new FormControl(),
            businessManagerPhone: new FormControl(),
            businessManagerMail: new FormControl(),
            nameClarificationNewDate: new FormControl(),
            nameClarification: new FormControl()
        });

        this.editReceiverPersonForm = new FormGroup({
            id: new FormControl(),
            oldReceiverName: new FormControl(),
            newReceiverName: new FormControl()
        });
        this.separateListItemForm = new FormGroup({
            id: new FormControl(),
            oldValue: new FormControl(),
            newValue: new FormControl()
        });
        if(this.type === 'new'){
            this.suaGovForm.patchValue({                
                orgNrOperator: customerJson.customerGenericValues.customerOrgId,
                addressCodeOperator: customerJson.customerGenericValues.customerSuaAddressCode,
                operatorName: customerJson.customerGenericValues.customerName,  
                operatorNationalityCode: customerJson.customerGenericValues.customerNationalityCode,              
                orgNrRegulator:  customerJson.customerGenericValues.regulatorOrgId,
                addressCodeRegulator: customerJson.customerGenericValues.regulatorSuaAddressCode,
                regulatorName:  customerJson.customerGenericValues.regulatorName,
                compSecContractLevel: 'levelOne',
                supplierType: 'headSupplier',
                generateCustomerSUA: this.autoGenerateCustomerSua
            });
        } else {
            this.suaGovForm.patchValue({
                generateCustomerSUA: this.autoGenerateCustomerSua
            });
        }
        this.getActiveEmployers();
        this.getActiveAuthorityEmployers();
       
        //this.disableConfiguredFields();
        this.compIndustryArray = customerJson.sapoFormValues.compIndustryArray;
        this.setInputWindow('SECURITYHANDLER');

        this.service.getAllReceivers().subscribe(
            data => {
                this.patchReceiverPersons(data)
                this.ready = true;
            },
            error => this.showError(error.error)
        );

        this.setupFormSubscriptions();
    }

    setupFormSubscriptions(): void {
        this.subscription.add(this.createProjectNameSubscription());
        this.subscription.add(this.createSupplierTypeSubscription());
    }

    createSupplierTypeSubscription(): Subscription {
        if(this.edition === 'company'){
            return this.suaGovForm.controls.supplierType.valueChanges.subscribe(value => {
                if (value === 'customerSupplier') {
                    this.suaGovForm.controls.parentId.reset()
                }
            })
        } else if(this.edition === 'government'){
            return this.suaGovForm.controls.supplierType.valueChanges.subscribe(value => {
                if (value === 'headSupplier') {
                    this.suaGovForm.controls.parentId.reset()
                }
            })
        }
    }

    createProjectNameSubscription(): Subscription {
        return this.suaGovForm.controls.compProjectName.valueChanges.subscribe(projectName => {
            if (this.valueExistsInList(projectName, this.uniqueDefaultProjectNames)) {
                this.getSupplierByProjectName(projectName);
            }
            else {
                this.headSupplier = null;
            }
        })
    }

    valueExistsInList(value: string, list: Array<string>) {
        return list.find(name => name === value);
    }

    disableConfiguredFields() {
        this.suaGovForm.get("orgNrOperator").disable();
        this.suaGovForm.get("operatorName").disable();
        this.suaGovForm.get("orgNrRegulator").disable();
        this.suaGovForm.get("regulatorName").disable();
    }

    /**
     * Opens view for editing a project
     * @param id Unique identifier for project to be edited
     */
    editProject(id) {
        this.viewService.getProjectById(id)      
        .subscribe(
            data => this.setProject(data),
            error =>  this.showError(error.error)   
        );
    }

    setCompany(companyId) {
        if (companyId != null) {
            for(let i=0; i < this.companies.length; i++) {
                if(this.companies[i].id === companyId){
                    this.selectedCompany = this.companies[i];
                }
            }
            this.patchEmployerForm(this.selectedCompany);
        }
    }

    validateInput(input, formArray) {
        let validInput = true;
        for(let i=0; i < formArray.length; i++) {
            if (input.toUpperCase() == formArray.value[i].reason.toUpperCase()) {
                validInput = false;
            }
        }
        return validInput;
    }

    deleteReasonFromList(reasonIndex) {
        let removeIndex:number = 0;
        if((<FormArray>this.suaForm.get('controlReason')).length == 1) {
            removeIndex = 0;
        } else {
            removeIndex = ++reasonIndex;
        }
        (<FormArray>this.suaForm.get('controlReason')).removeAt(removeIndex);
    }

    /**
     * Displays a project
     * @param project Project to be displayed
     */
    patchEmployerForm(employer) {
        this.suaGovForm.patchValue({
            compOrgId: employer.organisationId,
            compName: employer.name,
            employerId: employer.id 
        });
        this.disableEmployerInputFields();
       
        if(employer.suaStatus == "suaEmployer") {
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[1],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        } else if(employer.suaStatus == "inBidding") {
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[0],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        } else if (employer.suaStatus == "notApproved"){
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[2],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        } else if (employer.suaStatus == "cancelled") {
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[3],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        }
        // sets suaProjectStatus when creating new project
        this.suaGovForm.patchValue({
            suaProjectStatus: "Ej skickad"
        });
        this.companySelected = true;

        if (employer.organisationId === this.customerOrgId) {
            this.isCustomer = true;
            this.allMainOrganisationLocalOffices = employer.localOffices;
            this.availableLocalOfficeStrings = this.createLocalOfficeStringRepresentation(this.allMainOrganisationLocalOffices);
        } else {
            this.isCustomer = false;
            this.allMainOrganisationLocalOffices = [];
            this.availableLocalOfficeStrings = [];
        }
    }

    /**
     * Disables employers input fields that are automatically
     * filled by the application to prevent user data
     */
    disableEmployerInputFields() {
        this.suaGovForm.get('compOrgId').disable();
        this.suaGovForm.get('compName').disable();
    }

    /**
     * Sets form data for a project
     * @param project Project entity from backend
     */
    setProject(project) {
        // company related needs to be run first else project status will be reset when editing an existing project
        this.companySelected = true;
        this.selectedCompany = project.employer;
        this.setCompany(this.selectedCompany);
        this.disableEmployerInputFields();
        this.project = project;
        this.suaGovForm.patchValue({
            id: project.id,
            employerId: project.employer.id,
            compOrgId: project.employer.organisationId,
            compName: project.employer.name,
            
            compIndustry: project.compIndustry,
            govFullName: project.govFullName,
            suaCompanyStatus: project.suaCompanyStatus,
            suaDiaryUid: project.suaDiaryUid,
            suaName: project.suaName,
            suaProjectStatus: project.suaProjectStatus,
            supplierType: project.supplierType,
            parentId: null,

            compProjectName: project.compProjectName,
            
            compSecContractLevel: project.compSecContractLevel,
            compSecContractDate: (project.compSecContractDate === null ? "" : formatDate(project.compSecContractDate, 'yyyy-MM-dd', 'en')),            
            orgNrOperator: project.orgNrOperator,
            addressCodeOperator: project.addressCodeOperator,
            operatorName: project.operatorName,
            operatorNationalityCode: project.operatorNationalityCode !== null ? project.operatorNationalityCode : 'SE',
            orgNrRegulator: project.orgNrRegulator,
            addressCodeRegulator: project.addressCodeRegulator,
            regulatorName: project.regulatorName,
            selectedReceiverPerson: project.receiverPerson,

            secHandlerName: project.secHandlerName,
            secHandlerPhone: project.secHandlerPhone,
            secHandlerMail: project.secHandlerMail,
            
            projectSecManagerName: project.projectSecManagerName,
            projectSecManagerPhone: project.projectSecManagerPhone,
            projectSecManagerMail: project.projectSecManagerMail,

            businessManagerName: project.businessManagerName,
            businessManagerPhone: project.businessManagerPhone,
            businessManagerMail: project.businessManagerMail,
            nameClarificationNewDate: project.nameClarificationNewDate,
            nameClarification: project.nameClarification
        });
        if(project.contractVoidDate != null) {
            this.suaGovForm.patchValue({
                contractVoidDate: (project.contractVoidDate === null ? "" : formatDate(project.contractVoidDate, 'yyyy-MM-dd', 'en'))
            })
            this.setContractVoidDateExists(project.contractVoidDate);
        }
        this.service.getAllReceivers().subscribe(
            data => this.patchReceiverPersons(data),
            error => this.showError(error.error)
        );        

        if(this.edition === 'company'){
            if (this.isSubSupplier() || this.isHeadSupplier()) {
                this.getParentByChildId(project.id);
                this.showHierarchyFields = true
            }
            else if (!this.isHeadSupplier() && !this.isSubSupplier() && project.children && project.children.length > 0) {
                this.isPartOfHierarchy = true;
                this.showHierarchyFields = true
            }
        } else if (this.edition === 'government'){
            if (this.isSubSupplier()) {
                this.getParentByChildId(project.id);
                this.showHierarchyFields = true
            }
            else if (this.isHeadSupplier() && project.children && project.children.length > 0) {
                this.isPartOfHierarchy = true;
                this.showHierarchyFields = true
            }
        }

        this.suaGovForm.get('suaCompanyStatus').disable();
        this.setSecClass(project.compSecContractLevel);
        this.edit = true;

        if (project.employer.organisationId === this.customerOrgId) {
            this.isCustomer = true;
            this.allMainOrganisationLocalOffices = project.employer.localOffices;
            this.projectSpecificLocalOffices = project.localOffices;
            this.addedLocalOfficeStrings = this.createLocalOfficeStringRepresentation(this.projectSpecificLocalOffices);
            this.availableLocalOfficeStrings = this.createLocalOfficeStringRepresentation(this.filterAvailableLocalOfficies(this.allMainOrganisationLocalOffices));
        }
        // set the number of notes on first load. this will then be updated when a user adds/removes notes
        this.numOfNotes = this.project.notes.length;
    }

    getParentByChildId(childId: string) {
        this.viewService.getParentByChildId(childId).subscribe(
            (data: any) => {
                this.suaGovForm.controls.parentId.setValue(data ? data.id : null)
                this.isPartOfHierarchy = data ? true : false;
            },
            error => {
                // Do nothing because having parent is not required.
            }
        )
    }

    /**
     * Fetches all employers from the backend
     */
    getEmployers() {
        this.companyService.getActiveEmployers()
            .subscribe(
                data => this.setEmployers(data),
                error => this.showError(error.error)       
      )
    }

    /**
     * Sets the employer data
     * @param data 
     */
    setEmployers(data) {
        for(let i=0; i < data.length; i++) {
            if((data[i].suaStatus === 'suaEmployer' || data[i].suaStatus === 'inBidding') && !data[i].archived) {
                this.companies.push(data[i]);
            }
        }
       /* this.suaForm.patchValue({
            contractor: this.company[0].id
        })*/
    }

    /**
     * Helper to set contract security class variable used to show localoffices options.
     * @param inputClass contract security level
     */
    setSecClass(inputClass) {
        if(inputClass === 'levelOne'){
            this.selectedSecClass = 1
        } else if(inputClass === 'levelTwo'){
            this.selectedSecClass = 2
        } else if(inputClass === 'levelThree'){
            this.selectedSecClass = 3
        } else {
            this.selectedSecClass = inputClass;
        }
    }

    /**
     * Saves a project to the database
     * @param suaForm 
     * @param projectLead
     */
    async saveProject(suaForm) {
        suaForm.orgNrOperator = this.suaGovForm.get('orgNrOperator').value;
        suaForm.operatorName = this.suaGovForm.get('operatorName').value;
        suaForm.orgNrRegulator = this.suaGovForm.get('orgNrRegulator').value;
        suaForm.regulatorName = this.suaGovForm.get('regulatorName').value;        

        suaForm.supplierPlaceholderName = this.suaGovForm.get('compName').value;

        suaForm.receiverPerson = suaForm.selectedReceiverPerson;
        if(this.isCustomer && (this.selectedSecClass <= this.showLocalOfficesForLevel)){
            suaForm.localOffices = this.projectSpecificLocalOffices;
        } else {
            suaForm.localOffices = [];
        }
        suaForm.compSecContractDate = this.dateUpdateFix.fixDateOnUpdate(suaForm.compSecContractDate);
        suaForm.contractVoidDate = this.dateUpdateFix.fixDateOnUpdate(suaForm.contractVoidDate);

        suaForm.suaCompanyStatus =  this.suaGovForm.getRawValue().suaCompanyStatus;
        if(!this.receiverPersonInList(suaForm.receiverPerson)){
            this.confirmService.confirm(`${this.i18.rk.form.rkSubmitterMainLabel.toLowerCase()} "${this.i18.sua.form.confirmReciverPerson1}" "${suaForm.receiverPerson}" "${this.i18.sua.form.confirmReciverPerson2}`)
            .then(wantToSave => {
                if(wantToSave){
                    this.service.saveProject(suaForm, this.enableDigitalXmlExport).subscribe(
                        data => this.setRoute('project/view/' + data.id),
                        error => this.showError(error), 
                        () => this.showLoader = false
                    );
                }
            })
        } else {
            this.service.saveProject(suaForm, this.enableDigitalXmlExport).subscribe(
                data => this.setRoute('project/view/' + data.id),
                error => this.showError(error), 
                () => this.showLoader = false
            );
        }        
    }

    private isHeadSupplier(): boolean {
        return this.suaGovForm.value.supplierType === 'headSupplier';
    }

    private isSubSupplier(): boolean {
        return this.suaGovForm.value.supplierType === 'subSupplier';
    }

    private isCustomerSupplier(): boolean {
        return this.suaGovForm.value.supplierType === 'customerSupplier';
    }

    /**
     * Update existing project
     * @param suaForm project form data
     */
    async updateProject(suaForm) {
        suaForm.orgNrOperator = this.suaGovForm.get('orgNrOperator').value;
        suaForm.operatorName = this.suaGovForm.get('operatorName').value;
        suaForm.orgNrRegulator = this.suaGovForm.get('orgNrRegulator').value;
        suaForm.regulatorName = this.suaGovForm.get('regulatorName').value;

        suaForm.supplierPlaceholderName = this.suaGovForm.get('compName').value;
        suaForm.receiverPerson = suaForm.selectedReceiverPerson;
        if(this.isCustomer && (this.selectedSecClass <= this.showLocalOfficesForLevel)){
            suaForm.localOffices = this.projectSpecificLocalOffices;
        } else {
            suaForm.localOffices = [];
        }
        
        suaForm.compSecContractDate = ((suaForm.compSecContractDate === null || suaForm.compSecContractDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(suaForm.compSecContractDate));
        suaForm.contractVoidDate = ((suaForm.contractVoidDate === null || suaForm.contractVoidDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(suaForm.contractVoidDate));
        
        suaForm.suaCompanyStatus = this.suaGovForm.getRawValue().suaCompanyStatus;
        if(!this.receiverPersonInList(suaForm.receiverPerson)){
            this.confirmService.confirm(`${this.i18.rk.form.rkSubmitterMainLabel.toLowerCase()} "${this.i18.sua.form.confirmReciverPerson1}" "${suaForm.receiverPerson}" "${this.i18.sua.form.confirmReciverPerson2}"`)
            .then(wantToSave => {
                if(wantToSave){
                    this.service.updateProject(suaForm, this.enableDigitalXmlExport).subscribe(
                        data => this.setRoute('project/view/' + data.id),
                        error => this.showError(error),
                        () => this.showLoader = false
                    );
                }
            })
        } else {
            this.service.updateProject(suaForm, this.enableDigitalXmlExport).subscribe(
                data => this.setRoute('project/view/' + data.id),
                error => this.showError(error),
                () => this.showLoader = false
            );
        }        
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.confirmService.confirm(this.i18.sua.form.confirmNoSave)
            .then(result => {
                if(result) {
                    this.location.back();
                }
            });
    }

    /**
     * Show error
     * @param error error text
     */
    showError(error: any): void { 
        this.confirmService.error(this.appService.getTranslatedErrorMessage(error));        
    }

    showConfigurableError(error: any, title: string, showConfimButton: boolean, confirmButtonText: string, showCancelButton: boolean, cancelButtonText: string, type: string){
        let msg = error.split(',');
        this.ConfirmModalService.pop(msg, title, showConfimButton, confirmButtonText, showCancelButton, cancelButtonText, type);
    }

    /**
     * Sets the new route
     * @param destination Route destination
     */
    setRoute(destination) {      
        this.appService.setRoute(destination);
    }
    
    /**
     * Set tab view for address or contact person
     * @param type type of address
     */
    setInputWindow(type) {
        this.selectedView=type;
        this.previousType=type;
    }

    /**
     * Set the receiver person array data.
     * @param data Receiver persons fetched from server.
     */
    patchReceiverPersons(data): void {
        if (!this.rkReceiverActive) return;

        this.receiverPersonArray = data;

        const selectedReceiverPerson = this.suaGovForm.value.selectedReceiverPerson;
        if (selectedReceiverPerson != null && selectedReceiverPerson !== '' && !this.receiverPersonExists(selectedReceiverPerson)) {
            let modalData = this.validationModal.getModalArray();
            modalData[0] = this.i18.sua.form.receiverMissing;
            modalData[1] = `"${this.i18.sua.form.theReceiver}" "${this.suaGovForm.value.selectedReceiverPerson}" ${this.i18.sua.form.patchReceiver}`
            this.validationModal.pop();

            this.suaGovForm.controls.selectedReceiverPerson.reset()
        }
    }

    /**
    * Deletes a receiver person.
    * This will remove the person permanently from the list
    * @param inputReceiverPerson Name/contact details of a receiver person.
    */
    deleteRecieverPerson(inputReceiverPerson): void {
        const personToDelete = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === inputReceiverPerson);

        if (personToDelete) {
            this.confirmService.confirm(`${this.i18.sua.form.theReceiver} "${personToDelete.receiverName}" ${this.i18.sua.form.deleteReceiver}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.service.deleteRecieverPerson(personToDelete.id).subscribe(() => {
                            this.receiverPersonArray = this.receiverPersonArray.filter(receiverPerson => receiverPerson.id != personToDelete.id);
                            this.suaGovForm.controls.selectedReceiverPerson.reset();
                        },
                            error => this.showError(error)
                        );
                    }
                })
        }
        else {
        this.confirmService.error(this.i18.sua.form.errorDeleteReceiver);
        }
    }

    /**
     * Checks if the input receiver person exists in the array of all receiver persons.
     * @param receiverPerson Name/contact details of a receiver person.
     */
    receiverPersonExists(inputReceiverPerson: String): boolean {
        return this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === inputReceiverPerson ? true : false);
    }

    /**
     * Get all list of all uniquely named default projects
     */
    getAllUniqueDefaultProjectNames() {
        this.service.getAllUniqueProjectNames()
            .subscribe(
                data => this.setUniqueDefaultProjectNames(data),
                error => this.showError(error.error)
      )
    }

    /**
     * Set all unique project names to global variable
     * @param data
     */
    setUniqueDefaultProjectNames(data) {
        this.uniqueDefaultProjectNames = data
    }

    /**
     * Toggle the generate diary functionality
    */
    customDiaryDisabler() {
        if (this.suaGovForm.value.generateSequenceNumber) {
            this.suaGovForm.get('suaDiaryUid').disable();
            this.suaGovForm.patchValue({suaDiaryUid: this.i18.sua.form.generatingNumber});

        } else {
            this.suaGovForm.get('suaDiaryUid').enable();
            this.suaGovForm.patchValue({suaDiaryUid: null});
        }

    }

    /**
    * check if a receiver person already exists in the receiver person list
    */
    receiverPersonInList(selectedReceiverPerson: String): boolean {
        if(selectedReceiverPerson != null && selectedReceiverPerson !== ''){
            return this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName.toLowerCase() === selectedReceiverPerson.toLowerCase() ? true : false);
        } else if (selectedReceiverPerson == null || selectedReceiverPerson === '') {
            return true;
        }
    }

    /**
     * Helper to set contractVodiDateExists variable used to display/hide the name clarification field
     * used when updating an contract void date
     * @param date user specified date
     */
    setContractVoidDateExists(date){
        if(!isNaN(Date.parse(date))){
            this.contractVoidDateExists = true;
        } else {
            this.contractVoidDateExists = false;
        }
    }

    /**
     * Helper to set rk operator organisation id if operator selected from list
     * @param value boolean
     */
    setOperatorValues(value) {  
        if(value){
            let operator = this.suaOperatorFilterList.find(operator => operator.id === value);
            this.suaGovForm.patchValue({
                orgNrOperator: operator.organisationId,
                operatorNationalityCode: operator.countryCode
            });
            this.formValidator.validateOrgNrOperator(operator.organisationId);
        } else if (!value && this.project != null && this.suaGovForm.get('operatorName').value === this.project.operatorName) {
            this.suaGovForm.patchValue({
                orgNrOperator: this.project.orgNrOperator,
                operatorNationalityCode: this.project.operatorNationalityCode
            })
            this.formValidator.validateOrgNrOperator(this.project.organisationId);
        } else if (!value) {       
            if ((this.suaGovForm.get('operatorName').value != null && this.suaGovForm.get('operatorName').value != "" && customerJson.customerGenericValues.customerName != "") && this.suaGovForm.get('operatorName').value === customerJson.customerGenericValues.customerName) {
                this.suaGovForm.patchValue({
                    orgNrOperator: this.customerOrgId
                });
                this.formValidator.validateOrgNrOperator(this.customerOrgId.toString());
            } else if (!this.autoClearOrgNrOperator && this.suaGovForm.get('operatorName').value != null && this.suaGovForm.get('operatorName').value != ""){
                this.formValidator.validateOrgNrOperator(this.customerOrgId);
            } else {                
                this.suaGovForm.patchValue({
                    orgNrOperator: null
                });                
            }            
        }
    }

    /**
     * Helper to set sua regulator organisation id if regulator selected from list
     * @param value boolean
     */
    setRegulatorValues(value){
        if(value){
            let regulator = this.suaRegulatorFilterList.find(regulator => regulator.id === value);
            this.suaGovForm.patchValue({
                orgNrRegulator: regulator.organisationId
            });
        } else if (!value && this.project != null && this.suaGovForm.get('regulatorName').value === this.project.regulatorName) {
            this.suaGovForm.patchValue({
                orgNrRegulator: this.project.orgNrRegulator
            })
        } else if (!value){
            this.suaGovForm.patchValue({
                orgNrRegulator: null
            });
        }
    }

    /**
     * Get all employers from the backend
     * and populate the filter dropdown list
     */
     getActiveEmployers() {
        this.companyService.getActiveEmployers()
            .subscribe(
                data => this.setSUAOperatorFilterList(data),
                error => this.showError(error.error)
      )
    }

    /**
     * Get all authority employers from the backend
     * and populate the filter dropdown list
     */
     getActiveAuthorityEmployers() {
        this.companyService.getActiveAuthorityEmployers()
            .subscribe(
                data => this.setSUARegulatorFilterList(data),
                error => this.showError(error.error)
      )
    }

    /**
     * Helper to populate the operator filter list
     * @param data list of employers
     */
    setSUAOperatorFilterList(data){
        this.suaOperatorFilterList = data;
    }

    /**
     * Helper to populate the regulator filter list
     * @param data list of authority type employers
     */
    setSUARegulatorFilterList(data){
        this.suaRegulatorFilterList = data;
    }

    /**
     * Get the head supplier of the project matching the given project name.
     * @param projectName Name of a defaultproject
     */
    getSupplierByProjectName(projectName: string) {        
        let urlProjectName = this.sanitizeProjectName(projectName);
        if(this.edition === 'company'){
            this.service.getCustomerSupplierByProjectName(urlProjectName).subscribe(
                data => {
                    if (data) {                                               
                        this.headSupplier = data;                         
                        if(this.headSupplier != null && this.headSupplier.length > 0) {
                            this.showHierarchy(this.suaGovForm.value.supplierType);
                        }
                    }
                },
                error => this.showError(error)
            )
        } else if (this.edition === 'government'){
            this.service.getHeadSupplierByProjectName(urlProjectName).subscribe(
                data => {
                    if (data) {                        
                        this.headSupplier = data;  
                        if(this.headSupplier != null && this.headSupplier.length > 0) {
                            this.showHierarchy(this.suaGovForm.value.supplierType);
                        }
                    }
                },
                error => this.showError(error)
            )
        }
    }

    showHierarchy(supplierType: String) {
        this.showHierarchyHtml = this.setShowHierarchyHtml(supplierType);
    }

    /**
     * Helper to decide if the hierarchy html part should be shown to the user
     * @param supplierType the supplier type
     * @returns boolean
     */
     setShowHierarchyHtml(supplierType: String) {      
        if (this.edition === 'government'){
            if(supplierType != null && supplierType === 'headSupplier') {
                return false;
            } else if(supplierType != null && supplierType === 'subSupplier') {
                return true;
            } else {
                return false;
            }
        } else if (this.edition === 'company'){
            if(supplierType != null && supplierType === 'customerSupplier') {
                return false;
            } else if (supplierType != null && supplierType === 'headSupplier') {
                return true;
            } else if (supplierType != null && supplierType === 'subSupplier') {
                return true;
            } else {
                return false;
            }
        }
    }

    /**
     * Confirm hierarchy removal for a project
     */
    async confirmDissolveHierarchy(): Promise<void> {
        const wantsToDissolve = await this.confirmService.confirm(this.i18.sua.form.confirmDissolveHierarchy);
        if (wantsToDissolve) {
            this.dissolveProjectHierarchy()
        }
    }

    /**
     * Disconnects the project from any project hierarchy it is part of.
     */
    async dissolveProjectHierarchy(): Promise<void> {
        try {
            const dissolvedProject = await this.service.dissolveProjectHierarchy(this.suaGovForm.value.id).toPromise();
            this.setProject(dissolvedProject);
        } catch(error) {
            this.showError(error)
        }
    }

    /**
     * Check if a head supplier project exists
     * @param projectName project name to check
     * @returns
     */
    async findHeadProjectByName(projectName: string): Promise<any> {
        if (projectName != null) {
            projectName = this.sanitizeProjectName(projectName);
            try {
                const project = await this.service.findHeadProjectByName(projectName).toPromise();
                return project;
            } catch (error) {
                this.showError(error);
            }
        }        
        return null;
    }

    /**
     * Check if a customer project exists
     * @param projectName project name to check
     * @returns
     */
    async findCustomerProjectByName(projectName: string): Promise<any> {
        projectName = this.sanitizeProjectName(projectName);
        try {
            const project = await this.service.findCustomerProjectByName(projectName).toPromise();
            return project;
        } catch (error) {
            this.showError(error);
        }
        return null;
    }


    /**
     * Check if a head supplier project name is already taken
     * @returns
     */
    async headProjectNameTaken(): Promise<boolean> {
        const headProject = await this.findHeadProjectByName(this.suaGovForm.value.compProjectName);
        return headProject && headProject.id !== this.suaGovForm.value.id;
    }

    /**
     * Check if a customer supplier project name is already taken
     * @returns
     */
    async customerProjectNameTaken(): Promise<boolean> {
        const headProject = await this.findCustomerProjectByName(this.suaGovForm.value.compProjectName);
        return headProject && headProject.id !== this.suaGovForm.value.id;
    }

    /**
     * check if the supplier is already in the hierarchy
     * @param headProjectId uuid of head project
     * @param employerId uuid of the supplier
     * @returns
     */
    async supplierExistsInHierarchy(headProjectId: string, employerId: string): Promise<boolean> {
        try {
            const alreadyExists: boolean = await this.service.supplierExistsInHierarchy(headProjectId, employerId).toPromise();
            return alreadyExists;
        } catch (error) {
            this.showError(error);
        }
        return true;
    }

    openHeadProjectNameTakenDialog(): void {
        this.confirmService.error(`${this.i18.sua.form.openHeadProjectNameTakenDialog1} "${this.suaGovForm.value.compProjectName}". ${this.i18.sua.form.openHeadProjectNameTakenDialog2}`);
    }

    openSupplierAlreadyInHierarchyDialog(): void {
        this.confirmService.error(`${this.i18.sua.form.openSupplierAlreadyInHierarchyDialog1} ${this.selectedCompany.name} ${this.i18.sua.form.openSupplierAlreadyInHierarchyDialog2} "${this.suaGovForm.value.compProjectName}".`);
    }  


    /**
     * Creates a string representation of each local office object in the provided array
    */
    createLocalOfficeStringRepresentation(localOfficeArray) {
        let strings: any = [];
        if(localOfficeArray != null){        
            localOfficeArray.forEach(localOffice => {
                let officeStringRepresentation = localOffice.address + " - " + localOffice.postcode + " - " + localOffice.county;
                let office = {
                    id: localOffice.id,
                    address: localOffice.address,
                    postcode: localOffice.postcode,
                    county: localOffice.county,
                    stringRepresentation: officeStringRepresentation

                }
                //let stringRepresentation = localOffice.address + " - " + localOffice.postcode + " - " + localOffice.county;
                //strings.push(stringRepresentation);
                strings.push(office)
            });
        }

        //sortering innan return??
        return strings;
    }

    /**
     * This method removes all the local officies that has already been
     * assigned to the current SUA project from the bulk of available ones.
     *
     * @param localOfficeArray The local office arrray to filter.
    */
    filterAvailableLocalOfficies(localOfficeArray) {
        for (let localOffice of this.projectSpecificLocalOffices) {
            let index = localOfficeArray.findIndex(element => element.id === localOffice.id)
            if (index >= 0) {
                localOfficeArray.splice(index, 1);
            }
        }
        return localOfficeArray;
    }

    /**
     * This method checks if the provided value matches an existing
     * local office and then adds it to the current SUA project.
     *
     * @param inputAvailableLocalOfficeName The stringrepresentation used in the search-dropdown component.
    */
    addLocalOfficeToProject(inputAvailableLocalOfficeName) {
        this.availableLocalOfficeStrings.forEach(localOffice => {
            if(localOffice.stringRepresentation === inputAvailableLocalOfficeName){
                this.addedLocalOfficeStrings.push(localOffice);
                this.projectSpecificLocalOffices.push(localOffice);
                this.availableLocalOfficeStrings.splice(this.availableLocalOfficeStrings.findIndex((element) => element.id === localOffice.id), 1); // hitta id för splice
                this.suaGovForm.controls.availableLocalOfficeName.reset();
                this.suaGovForm.controls.addedLocalOfficeName.setValue(inputAvailableLocalOfficeName);
                this.addButtonEnabled = false;
            }
        });
    }

    /**
     * This method checks if the provided value matches an existing
     * local office and then removes it from the current SUA project.
     *
     * @param inputAddedLocalOfficeName The stringrepresentation used in the search-dropdown component.
    */
    removeLocalOfficeFromProject(inputAddedLocalOfficeName) {
        this.addedLocalOfficeStrings.forEach(localOffice => {
            if(localOffice.stringRepresentation === inputAddedLocalOfficeName){
                this.availableLocalOfficeStrings.push(localOffice);
                this.projectSpecificLocalOffices.splice(this.addedLocalOfficeStrings.findIndex((element) => element.id === localOffice.id), 1);
                this.addedLocalOfficeStrings.splice(this.addedLocalOfficeStrings.findIndex((element) => element.id === localOffice.id), 1); // hitta id för splice
                this.suaGovForm.controls.addedLocalOfficeName.reset();
                this.suaGovForm.controls.availableLocalOfficeName.setValue(inputAddedLocalOfficeName);
                this.removeButtonEnabled = false;
            }
        });
    }

    setAddButtonEnabled(data){
        if(data){
            this.addButtonEnabled = true;
        }
    }

    setRemoveButtonEnabled(data){
        if(data){
            this.removeButtonEnabled = true;
        }
    }

    sanitizeProjectName(projectName){
        let result = projectName.replace('/', '%2F');
        result = result.replace('\\', '%5C');
        return result;
    }

    deSanitizeProjectName(projectName){
        let result = projectName.replace('%2F', '/');
        result = result.replace('%5C', '\\');
        return result;
    }

    /**
     * Anchor
     * @param target id
     */
     public anchor(target): void {
        this.appService.scrollToTarget(target);
    }   
    

    /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
     setNumOfNotes(numOfNotes: number){
        if(numOfNotes != null && !Number.isNaN(numOfNotes)){
            this.numOfNotes = numOfNotes;
        } else {
            this.numOfNotes = this.project.notes.length;
        }
    }

    /**
     * helper to open the edit receiverperson modal.
     */
    openEditReceiverModal(){
        this.ngxSmartModalService.getModal('receiverPersonEditModal').open();
    }

    /**
     * helper to close the edit receiverperson modal.
     */
    closeEditReceiverModal(){
        this.editReceiverPersonForm.reset();
        this.ngxSmartModalService.getModal('receiverPersonEditModal').close();
    }

    /**
    * Allows for deletion of a receiver person
    * This will remove the person permanently from the list
    */
    editReceiverPerson(oldReceiverPerson): void {
        const personToEdit = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === oldReceiverPerson);
        this.editReceiverPersonForm.patchValue({
            id: personToEdit.id,
            oldReceiverName: personToEdit.receiverName
        })
        const newReceiverName = this.editReceiverPersonForm.value.newReceiverName;

        this.service.updateReceiver(this.editReceiverPersonForm.value)
            .subscribe(
                data => {
                    this.suaGovForm.patchValue({
                        selectedReceiverPerson: newReceiverName
                    });
                    this.patchReceiverPersons(data);
                    this.closeEditReceiverModal();
                },
                error => this.showError(error)
            );
    }

    /**
     * If auto generations of customer agreement is selected (company edition)
     */
    setGeneratedCustomerSua(): void {
        this.autoGenerateCustomerSua = this.suaGovForm.get('generateCustomerSUA').value;

        if(this.suaGovForm.get('supplierType').value == 'customerSupplier' || this.suaGovForm.get('supplierType').value == 'subSupplier') {
            this.suaGovForm.patchValue({
                supplierType: 'headSupplier'
            });            
        }
    }

    /**
     * Open modal prepare form depending on what type to perform the update on
     * @param type type to be updated
     */
    openEditModal(type: string) {
        if (type === 'receiverPerson' && this.selectedReceiverPersonId !== null && this.selectedReceiverPersonId !==''){
            const receiverPersonToEdit = this.receiverPersonArray.find(receiverPerson => receiverPerson.id === this.selectedReceiverPersonId);
            this.separateListItemForm.patchValue({
                id: receiverPersonToEdit.id,
                oldValue: receiverPersonToEdit.receiverName
            })
        }
        if (type === 'addressCodeOperator' && this.selectedAddressCodeId !== null && this.selectedAddressCodeId !==''){
            const addressCodeOperatorToEdit = this.addressCodeFilterList.find(addressCode => addressCode.id === this.selectedAddressCodeId);
            this.separateListItemForm.patchValue({
                id: addressCodeOperatorToEdit.id,
                oldValue: addressCodeOperatorToEdit.addressCode
            })
        }
        this.ngxSmartModalService.setModalData(type, 'editModal', true);
        this.ngxSmartModalService.getModal('editModal').open();
    }

    /**
     * helper to close the edit receiverperson modal.
     */
    closeEditModal(type){
        if(type === 'receiverPerson') {
            this.selectedReceiverPersonId = ''
        } else if(type === 'addressCodeOperator') {
            this.selectedAddressCodeId = ''
        } 
        this.separateListItemForm.reset();
        this.ngxSmartModalService.getModal('editModal').close();
    }
    
    /**
     * call specific update function depending on which of profession, receiverPerson or addressCodeOperator is to be updated 
     * @param type type to be updated
     */    
    editTypeData(type): void {
        if (type === 'receiverPerson'){
            const newReceiverName = this.separateListItemForm.value.newValue;

            this.service.updateReceiver(this.separateListItemForm.value)
                .subscribe(
                    data => {
                        this.suaGovForm.patchValue({
                            selectedReceiverPerson: newReceiverName
                        });
                        this.patchReceiverPersons(data);
                        this.closeEditModal('receiverPerson');
                    },
                    error => this.showError(error)
                );
        } else if (type === 'addressCodeOperator'){
            const newAddressCodeName = this.separateListItemForm.value.newValue;
            this.service.updateAddressCode(this.separateListItemForm.value)
                .subscribe(
                    data => {
                        this.patchSeparateListItem('addressCodeOperator', data, newAddressCodeName);
                        this.closeEditModal('addressCodeOperator');
                    },
                    error => this.showError(error)
                );
        }
    }
   
    /**
     * set the id to be updated
     * @param id id of receiverPerson
     */
    setSelectedReceiverPersonId(id: string) {
        this.selectedReceiverPersonId = id;
    }
    
    /**
     * Patch the form after the update has been done.
     * @param type type to patch after update
     * @param data data from backend
     * @param currentValue old value
     */
    patchSeparateListItem(type: string, data: any, currentValue: string){
        let valueToPatch;
        if(type === 'receiverPerson') {
            valueToPatch = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === currentValue)
            this.suaGovForm.patchValue({
                receiverPerson: valueToPatch.professionName
            })
            this.patchReceiverPersons(data);
        } else if(type === 'addressCodeOperator') {
            this.addressCodeFilterList = data;
            valueToPatch = this.addressCodeFilterList.find(addressCode => addressCode.addressCode === currentValue)
            this.suaGovForm.patchValue({
                addressCodeOperator: valueToPatch.addressCode
            })
        }
    }
    
    /**
     * Helper to autocomplete a date with missing dividers '-'
     * @param date date string to patch
     * @param form the form to use
     * @param formControlName the formControlName to be patched with the date.
     */
    patchDate(date: string, form: string, formControlName: string) {
        if(date != null) {
            date = date.replace(/-/g,'');
        }
        if((date != null && date.trim() !== '') && 
        (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
            let yearPossition = 4;
            let monthPossition = 6;
            let dateDivader = '-'
            let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
            if(form === 'suaGovForm') {
                this.suaGovForm.patchValue({
                    [formControlName]: patchedDate
                })
                if(formControlName === 'contractVoidDate') {
                    this.setContractVoidDateExists(patchedDate)
                }
            }
        }
    }
    
    /**
     * Get all operator address codes
     */
    getAllAddressCodes() {
        this.service.getAllAddressCodes()
        .subscribe(
            data => this.setAddressCodeFilterList(data),
            error => this.showError(error.error)
        );
    }
    
    /**
     * set the id to be updated
     * @param id id of addressCodeOperator
     */
    setSelectedAddressCodeId(id: string) {
        this.selectedAddressCodeId = id;
    }

    /**
     * Set the addressCodes drop-down with existing codes
     * @param data 
     */
    setAddressCodeFilterList(data: any): void {
        this.addressCodeFilterList = data;
    }   

    /**
     * 
     * @param value If written addressCode already exists
     */
    setAddressCodeExists(value){
        this.addressCodeExists = value;
    }

    /**
    * Allows for deletion of an address code
    * This will remove the adress code permanently from the list
    */
     deleteAddressCodeFromList(addressCode): void {
        const addressCodeToDelete = this.addressCodeFilterList.find(code => code.addressCode === addressCode);

        if (addressCodeToDelete) {
            this.confirmService.confirm(`"${addressCodeToDelete.addressCode}" ${this.i18.rk.filterList.rkRemoveFromList}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.service.deleteAddressCode(addressCodeToDelete.id)
                        .subscribe(
                            data => {
                                this.suaGovForm.controls.addressCodeOperator.reset();
                                this.setAddressCodeExists(false);
                                this.getAllAddressCodes();
                            },
                            error => this.showError(error.error)
                        );
                    }
                })
        }
        else {
            this.confirmService.error(this.i18.rk.filterList.rkRemoveErrorFromList);
        }
    }
}